import * as ActionConfigurationManager from './config.actions';

export const createCaseDirectMarketing = ActionConfigurationManager.CREATE_A_CASE_DIRECT_MARKETING;
export const storeUserDirectMarketing = ActionConfigurationManager.STORE_USER_DIRECT_MARKETING;
export const createCaseDirectMarketingSuccess = ActionConfigurationManager.CREATE_A_CASE_DIRECT_MARKETING_SUCCESS;
export const createCaseDirectMarketingFailed = ActionConfigurationManager.CREATE_A_CASE_DIRECT_MARKETING_FAILED;
export const storeUserDirectMarketingSuccess = ActionConfigurationManager.STORE_USER_DIRECT_MARKETING_SUCCESS;
export const storeUserDirectMarketingFailed = ActionConfigurationManager.STORE_USER_DIRECT_MARKETING_FAILED;
